import React, { Component } from 'react';
import moment from 'moment';

let DateTime = (props) => {
  const format = props.format ? props.format : 'MM/DD/YYYY HH:mm';
  return (
    <span>
      {
        moment(Date.parse(props.dateTime)).format(format)
      }
    </span>
  )
}

export default DateTime;



// WEBPACK FOOTER //
// ./components/UI/DateTime/DateTime.jsx